import { Directive } from '@angular/core';
import { getCentralisationInsurerLabel } from 'src/app/_enums/centralisation-insurer.enum';
import { getSexEnumLabel } from 'src/app/_enums/sex.enum';
import {
  getOwnDescriptionEnum,
  getSavingReasonEnumLabel,
  getThirdPillarSituationLabel,
  ThirdPillarSituationEnum,
} from 'src/app/_enums/third-pillar.enum';
import { getBooleanLabel } from 'src/app/_helpers/utils';
import { ThirdPillarMetadata } from 'src/app/_types/lead.types';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class ThirdPillarMetadataComponentAbstract extends BaseMetadataComponent<ThirdPillarMetadata> {
  getBooleanLabel = getBooleanLabel;

  getOwnDescriptionLabel = getOwnDescriptionEnum;

  getSavingReasonLabel = getSavingReasonEnumLabel;

  getThirdPillarSituationLabel = getThirdPillarSituationLabel;

  Situation = ThirdPillarSituationEnum;

  getSexEnumLabel = getSexEnumLabel;

  getCentralisationInsurerLabel = getCentralisationInsurerLabel;
}
